/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useState } from "react";
import { PermissionInputControl } from "./permission-input-control";
import { PermissionInputHeader } from "./permission-input-header";
import {
  default_permission,
  getPermissionLabel,
} from "../react-hook/default-permission";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const PermissionInput = ({
  value,
  onChange,
  isRoleDisabled,
}: //   onChange,
{
  value: any;
  onChange: (prop: any) => void;
  isRoleDisabled: boolean;
}) => {
  const [search, searchText] = useState("");
  const checkExist = (prop: string) => {
    const tempSearch = search.toLowerCase();
    const temp_prop =
      typeof prop === "string" ? getPermissionLabel(prop).toLowerCase() : prop;
    return temp_prop.includes(tempSearch);
  };

  const isSearchNotExist = useMemo(() => {
    const temp = default_permission.filter((item: any) => checkExist(item.name));
    return temp.length === 0;
  }, [search]);

  return (
    <div
      className="max-h-[350px] border overflow-y-auto text-[14px] rounded-sm"
      style={{ scrollbarWidth: "thin" }}
    >
      <PermissionInputHeader search={search} searchText={searchText} />
      <div>
        {isSearchNotExist ? (
          <div className="p-10 text-center text-slate-700">
            No records found for "{search}"
          </div>
        ) : null}
        {default_permission.map((item: any, index: number) => {
          const isExist = checkExist(item.name);
          const current_value =
            value.find((v: any) => v.name === item.name) || item;

          return (
            <PermissionInputControl
              key={index}
              value={current_value}
              onChange={onChange}
              list={value}
              isRoleDisabled={isRoleDisabled}
              show={isExist}
            />
          );
        })}
      </div>
    </div>
  );
};
